export default {"src":"/_next/static/media/ESFlag.7e82b9db.svg","height":18,"width":24};